import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { textModels } from '@/lib/models/text';
import { useReactFlow } from '@xyflow/react';
import type { LLMNodeProps } from '.';
import { NodeLayout } from '../layout';
import { ModelSelector } from '../model-selector';

type LLMPrimitiveProps = LLMNodeProps & {
  title: string;
};

const getDefaultModel = (models: typeof textModels) => {
  const defaultModel = models
    .flatMap((model) => model.models)
    .find((model) => model.default);

  if (!defaultModel) {
    return models[0]?.models[0]?.id || '';
  }

  return defaultModel.id;
};

export const LLMPrimitive = ({ data, id, type, title }: LLMPrimitiveProps) => {
  const { updateNodeData } = useReactFlow();

  const modelId = data.model ?? getDefaultModel(textModels);
  const systemPrompt = data.systemPrompt || '';

  const handleModelChange = (value: string) => {
    updateNodeData(id, { model: value });
  };

  const handleSystemPromptChange = (value: string) => {
    updateNodeData(id, { systemPrompt: value });
  };

  return (
    <NodeLayout
      id={id}
      data={data}
      title={title}
      type={type}
      className="node-llm w-96"
    >
      <div className="space-y-4 p-4">
        {/* Model Selector */}
        <div className="space-y-2">
          <Label className="font-medium text-muted-foreground text-sm">
            Model
          </Label>
          <ModelSelector
            value={modelId}
            options={textModels}
            onChange={handleModelChange}
            className="!w-full"
          />
        </div>

        {/* System Prompt */}
        <div className="space-y-2">
          <Label className="font-medium text-muted-foreground text-sm">
            System Prompt
          </Label>
          <Textarea
            placeholder="e.g., You are a helpful assistant."
            value={systemPrompt}
            onChange={(e) => handleSystemPromptChange(e.target.value)}
            className="min-h-20 resize-none"
          />
        </div>
      </div>
    </NodeLayout>
  );
};
